import { render, staticRenderFns } from "./Qualification.vue?vue&type=template&id=2af0c0a0&"
import script from "./Qualification.vue?vue&type=script&lang=js&"
export * from "./Qualification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Qualification.vue"
export default component.exports